import React from "react";

const Footer = () => {
  return (
    <div className="flex py-1.5 bg-[#FFFFFF9E] text-black text-[13px] shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] justify-center font-serif z-20">
      © Site developed and maintained by KPMG Advisory Services Pvt. Ltd.
    </div>
  );
};

export default Footer;
